/**
 * January 2018
 *  S |  M |  T |  W |  T |  F |  S
 *    |  1 |  2 |  3 |  4 |  5 |  6
 *  7 |  8 |  9 | 10 | 11 | 12 | 13
 * 14 | 15 | 16 | 17 | 18 | 19 | 20
 * 21 | 22 | 23 | 24 | 25 | 26 | 27
 * 28 | 29 | 30 | 31 |    |    |
 * https://www.timeanddate.com/calendar/monthly.html?year=2018&month=1&country=1
 */

export const jan1 = new Date(2018, 0, 1);
export const jan1At1pm = new Date(2018, 0, 1, 13);
export const jan2 = new Date(2018, 0, 2);
export const jan3 = new Date(2018, 0, 3);
export const jan4 = new Date(2018, 0, 4);
export const jan5 = new Date(2018, 0, 5);
export const jan6 = new Date(2018, 0, 6);
export const jan7 = new Date(2018, 0, 7);
export const jan8 = new Date(2018, 0, 8);
export const jan9 = new Date(2018, 0, 9);
export const jan10 = new Date(2018, 0, 10);
export const jan11 = new Date(2018, 0, 11);
export const jan12 = new Date(2018, 0, 12);
export const jan13 = new Date(2018, 0, 13);
export const jan15 = new Date(2018, 0, 15);
export const jan16 = new Date(2018, 0, 16);
export const jan17 = new Date(2018, 0, 17);
export const jan18 = new Date(2018, 0, 18);
export const jan19 = new Date(2018, 0, 19);
export const jan20 = new Date(2018, 0, 20);

export const dec15_2022 = new Date(2022, 11, 15);
export const jan7_2023 = new Date(2023, 0, 7);
export const mar1_2023 = new Date(2023, 2, 1);
export const mar7_2023 = new Date(2023, 2, 7);
export const may7_2023 = new Date(2023, 4, 7);

export const today = new Date();

export function newDate() {
  return jan1;
}
